import React, { useEffect, useState } from "react";
import axiosInstance from "../../api/axiosInstance";
import "./CategoryAdmin.css";
import CommonDrawer from "../common/CommonDrawer";
import { toast } from "react-toastify";

function CategoryAdmin() {
  const [categories, setCategories] = useState([]);
  const [name, setName] = useState("");
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [editId, setEditId] = useState(null);
  const [open, setOpen] = useState(false);

  const loadCategories = async () => {
    const res = await axiosInstance.get("categories/");
    setCategories(res.data);
  };

  useEffect(() => {
    loadCategories();
  }, []);

  const saveCategory = async () => {
    if (!name.trim()) return toast.error("Category name required");

    const fd = new FormData();
    fd.append("name", name);
    if (image) fd.append("image", image);

    if (editId) {
      await axiosInstance.put(`categories/?id=${editId}`, fd);
    } else {
      await axiosInstance.post("categories/", fd);
    }

    resetForm();
    loadCategories();
  };

  const resetForm = () => {
    setName("");
    setImage(null);
    setPreview(null);
    setEditId(null);
    setOpen(false);
  };

const editCategory = (c) => {
  setEditId(c.id);
  setName(c.name);
  setPreview(c.image ? c.image : null);
  setOpen(true);
};

  const deleteCategory = async (id) => {
    if (window.confirm("Delete category?")) {
      await axiosInstance.delete(`categories/?id=${id}`);
      loadCategories();
    }
  };

  return (
    <div className="category-admin">
      <div className="header">
        <h2>Categories</h2>
        <button
          className="primary-btn"
          onClick={() => {
            resetForm();
            setOpen(true);
          }}
        >
          + Add Category
        </button>
      </div>

      <div className="table">
        <div className="table-head">
          <span>Image</span>
          <span>Name</span>
          <span>Actions</span>
        </div>

        {categories.map((c) => (
          <div className="table-row" key={c.id}>
            <div>
              {c.image && (
                <img
  src={c.image}
  alt={c.name}
  className="category-img"
/>
              )}
            </div>

            <span className="name">{c.name}</span>

            <div className="actions">
              <button className="edit" onClick={() => editCategory(c)}>
                Edit
              </button>
              <button
                className="danger"
                onClick={() => deleteCategory(c.id)}
              >
                Delete
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* DRAWER */}
      <CommonDrawer
        open={open}
        title={editId ? "Edit Category" : "Add Category"}
        onClose={resetForm}
      >
        <input
          className="input"
          placeholder="Category name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />

        <input
          type="file"
          accept="image/png,image/jpeg"
          onChange={(e) => {
            setImage(e.target.files[0]);
            setPreview(URL.createObjectURL(e.target.files[0]));
          }}
        />

        {preview && (
          <img src={preview} alt="Preview" className="preview-image" />
        )}

        <button className="primary-btn full" onClick={saveCategory}>
          {editId ? "Update" : "Save"}
        </button>
      </CommonDrawer>
    </div>
  );
}

export default CategoryAdmin;
